export default __webpack_public_path__ + "static/media/logo.e2110e97.png";